import React, { useState } from "react";
import { useTranslations } from 'next-intl'

const AvgComponent = () => {
    const t = useTranslations('')
    const [isOpen, setIsOpen] = useState(false);

    const toggleContent = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            <div className={`avg-prices-toggle ${isOpen ? "shown" : ""}`} onClick={toggleContent}>
                <i className="fa fa-arrow-left"></i>
            </div>

            <div className={`avg-prices-content ${isOpen ? "shown" : ""}`}>
                <div className="avg-price-title">{t('Regions')}</div>
                <div className="avg-price-item">
                    {t('Center')} - <span>$3243</span>
                </div>
                <div className="avg-price-item">
                    {t('Large Center')} - <span>$2009</span>
                </div>
                <div className="avg-price-item">
                    {t('Arabkir')} - <span>$1975</span>
                </div>
                <div className="avg-price-item">
                    {t('Kanaker-Zeytun')} - <span>$1596</span>
                </div>
                <div className="avg-price-item">
                    {t('Ajapnyak')} - <span>$1454</span>
                </div>
                <div className="avg-price-item">
                    {t('Davitashen')} - <span>$1609</span>
                </div>
                <div className="avg-price-item">
                    {t('Nork-Marash')} - <span>$3507</span>
                </div>
                <div className="avg-price-item">
                    {t('Shengavit')} - <span>$1649</span>
                </div>
                <div className="avg-price-item">
                    {t('1-6 Nork district')} - <span>$1280</span>
                </div>
                <div className="avg-price-item">
                    {t('7-9 Nork district')} - <span>$1121</span>
                </div>
                <div className="avg-price-item">
                    {t('Avan, Avan-Arinj')} - <span>$1410</span>
                </div>
                <div className="avg-price-item">
                    {t('Erebuni')} - <span>$1364</span>
                </div>
                <div className="avg-price-item">
                    {t('Malatia-Sebastia')} - <span>$1262</span>
                </div>
            </div>
        </>
    );
};

export default AvgComponent;
